function checkForFieldsWithErrors(state) {
  const fieldsWithErrors = Object.keys(state).filter(
    field => state[field].error
  );

  return fieldsWithErrors;
}

export default checkForFieldsWithErrors;
